import { useEffect, useCallback, useState } from 'react';

import {
  ProductRecommendationsJsonItemsMapping,
  MlProductRecs,
} from '@narvar/nth-hook-loma';
import { useCustomComponentStateContext } from './useCustomComponentState';
import { getMLProductRecs } from '../graphql';
import useApolloClient from '../lib/apolloClient';

export const MLProductRecsItemsLookup = 'recommendations';
export const MLProductRecsItemsMap: ProductRecommendationsJsonItemsMapping[] = [
  {
    type: 'URL',
    lookup: 'productUrl',
  },
  {
    type: 'IMAGE',
    lookup: 'imageUrl',
  },
  {
    type: 'NAME',
    lookup: 'productName',
  },
  {
    type: 'PRICE',
    lookup: 'price',
  },
  {
    type: 'PRICE_GRANULAR',
    lookup: 'priceGranular',
  },
  {
    type: 'SALE_PRICE',
    lookup: 'salePrice',
  },
  {
    type: 'SALE_PRICE_GRANULAR',
    lookup: 'salePriceGranular',
  },
  {
    type: 'BRAND',
    lookup: 'brand',
  },
  {
    type: 'RATING',
    lookup: 'rating',
  },
];

const useMLProductRecs = ({
  mlProductRecsEnabled,
}: {
  mlProductRecsEnabled: boolean | undefined;
}): unknown => {
  const { state } = useCustomComponentStateContext();
  const [mlProdctRecsData, setMLProductRecsData] = useState<MlProductRecs>();
  const apolloClient = useApolloClient();
  const {
    itemIds: productIds,
    productSkus,
    retailerMoniker,
    orderNumbers,
    trackingNumbers,
  } = state?.pageContext || {};
  const [orderNumber] = orderNumbers ?? [];
  const [trackingNumber] = trackingNumbers ?? [];

  const isMLProductRecs =
    state?.queryData?.retailerSettings?.productRecommendations?.type ===
    'ML_ENGINE';

  const fetchProductRecs = useCallback(async () => {
    try {
      const response =
        apolloClient &&
        (await apolloClient.query({
          query: getMLProductRecs,
          variables: {
            productIds,
            productSkus,
            retailerMoniker,
            orderNumber,
            trackingNumber,
          },
        }));

      const recs = (
        response?.data as { mlProductRecs: MlProductRecs } | undefined
      )?.mlProductRecs;

      setMLProductRecsData(recs);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error fetching recommendations', e);
    }
  }, [
    productIds,
    productSkus,
    retailerMoniker,
    orderNumber,
    trackingNumber,
    apolloClient,
  ]);

  useEffect(() => {
    if (!isMLProductRecs || !mlProductRecsEnabled) return;

    fetchProductRecs().catch((e) => console.error(e));
  }, [mlProductRecsEnabled, isMLProductRecs, fetchProductRecs]);

  return mlProdctRecsData;
};

export default useMLProductRecs;
